import { render, staticRenderFns } from "./StarGraphic.vue?vue&type=template&id=3b68ac36&functional=true&"
import script from "./StarGraphic.vue?vue&type=script&lang=js&"
export * from "./StarGraphic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports